<script setup>
import { ref, watch } from 'vue';
import { __ } from '@/utils'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useField } from 'vee-validate';

const props = defineProps({
    active: Boolean,
    date: {
        type: Array,
    }
});

const { handleChange: departureDate } = useField('departureDate');

const emit = defineEmits(['accept']);

const datepicker = ref(null);

// Calculate min and max dates
const today = new Date();
const minDate = new Date(today);
minDate.setDate(today.getDate() - 1);
const maxDate = new Date(today);
maxDate.setMonth(today.getMonth() + 3);

// Set default date to today
const date = ref(today);
departureDate(today)

const handleDateSelect = (value) => {
	emit('accept', value)
	date.value = value;
	datepicker.value.closeMenu();
    departureDate(value);
}

const daysOfWeek = [
    __('su'),
    __('m'),
    __('tu'),
    __('w'),
    __('th'),
    __('f'),
    __('sa'),
];

watch(date, (newDate) => {
    const pickedDate = new Date(newDate);

    departureDate(pickedDate)
});
</script>
<template>
   <div class="calendar">
    <VueDatePicker
        ref="datepicker"
        locale="he"
        :multi-calendars="false"
        :day-names="daysOfWeek"
        :week-start="0"
        format="dd/MM/yyyy"
        :clearable="false"
        :hide-navigation="['time', 'minutes', 'hours', 'seconds']"
        :action-row="{ showSelect: false, showPreview: false, showCancel: false }"
        :enable-time-picker="false"
        v-model="date"
        :min-date="minDate"
        :max-date="maxDate"
		@date-update="handleDateSelect"
		id="datepicker-input"
    >
        <template #input-icon>
            <img class="dp__icon" :src="`${theme_path.url}/resources/images/svg/icon-calendar.svg`"/>
        </template>
        <template #arrow-left>
            <img class="slot-icon" :src="`${theme_path.url}/resources/images/svg/icon-arrow-left-gradient.svg`" />
        </template>
        <template #arrow-right>
            <img class="slot-icon slot-icon--reversed" :src="`${theme_path.url}/resources/images/svg/icon-arrow-left-gradient.svg`" />
        </template>
    </VueDatePicker>
</div><!-- /.calendar -->
</template>